import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Preview from '@mui/icons-material/Preview';
import { delItemMaterial } from '../../../Store/PHPSlice/Item';

const TableBody = ({
    id,
    itemId,
    itemNm,
    brandId,
    brandNm,
    departId,
    departNm,
    serialNumber,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    // const getDelete = useSelector((state) => state.companyData.deleteComp);
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/item-material-edit/${itemId}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handleViewClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/material-view/${itemId}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this Material?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            const postobj = {
                itemId: itemId,
                brandId: brandId
            };
            dispatch(delItemMaterial(postobj))
                .then(() => {
                    // Reload the page to show updated results
                    // toast("Rack Deleted Sucessfully");
                    alert("Record Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting company:", error);
                    toast.error("Failed to delete company");
                });
        }
    };





    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{serialNumber}</TableCell>

                {/* <TableCell component="th" scope="row" sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <Typography variant="subtitle2" noWrap>
                        {departNm}
                    </Typography>
                </TableCell> */}
                <TableCell component="th" scope="row" sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <Typography variant="subtitle2" noWrap>
                        {itemNm}
                    </Typography>
                </TableCell>

                <TableCell component="th" scope="row" sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <Typography variant="subtitle2" noWrap>
                        {brandNm}
                    </Typography>
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <Preview className="cursor-pointer" onClick={handleViewClick} />
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className="cursor-pointer" onClick={handleEditClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className="cursor-pointer" onClick={handleDeleteClick} />
                </TableCell>
            </TableRow>
            <ToastContainer />
        </>
    );
};

export default TableBody;
